module.exports = __webpack_public_path__ + "static/img/ico_coupon_nodata.1bb5778.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/ico_coupon_nodata.svg
// module id = /4vf
// module chunks = 10